import 'dayjs/locale/nl'
import './App.css'
import './i18n'

import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import localeData from 'dayjs/plugin/localeData'
import i18n from 'i18next'
import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import Smartlook from 'smartlook-client'

import { clearFormProgress } from '@/hooks/useTrackFormProgress.ts'
import { isVelthuis } from '@/utils/common.ts'

dayjs.extend(localeData)
dayjs.extend(customParseFormat)

// Set the locale before anything renders or any router loader runs: dayjs
// instances capture the global locale at construction, so a post-render
// effect would leave first-load dates (and loader-built dayjs values) in
// the default English locale. i18n inits synchronously on import above.
dayjs.locale(i18n.language)
i18n.on('languageChanged', (language) => dayjs.locale(language))

clearFormProgress()

const App = () => {
  // init smartlook for velthuis
  useEffect(() => {
    if (isVelthuis) {
      const projectId = import.meta.env.VELTHUIS_SMARTLOOK_KEY
      Smartlook.init(projectId, { region: 'eu' })
    }
  }, [])

  return <Outlet />
}

export default App
